import { CustomData } from './datapoints/AriaDatapoint';
import { AriaDatapoint } from './datapoints/AriaDatapoint';
import DevOnlyDatapoint from './datapoints/DevOnlyDatapoint';
import logDatapoint from './logDatapoint';
import { wrapConsole } from 'owa-react-strict-dev-logging';

export let shouldLogInDev: (datapoint: AriaDatapoint) => boolean = () => false;

// as a side-effect during setup, we override the console object with a new console object
// that captures react warnings and logs them to a new aria table.
if (process.env.NODE_ENV === 'dev') {
    const REACT_STRICT_EVENT_NAME_PREFIX = 'ReactStrictMode_';
    const oldConsole = window.console;

    /**
     * Whether this datapoint should be logged in development mode
     *
     * Right now this is only ReactStrictMode errors, as ReactStrictMode warnings only get logged in dev.
     */
    shouldLogInDev = (datapoint: AriaDatapoint) => {
        return datapoint instanceof DevOnlyDatapoint;
    };

    // hijack console.warn to recognize react errors and log them in development
    (window.console as any) = wrapConsole(oldConsole, (eventName: string, data: CustomData) => {
        logDatapoint(new DevOnlyDatapoint(`${REACT_STRICT_EVENT_NAME_PREFIX}${eventName}`, data));
    });
}
